'use client';
import { AdminTRPCProvider, TRPCProvider } from '@bitbot/api';
import { UIProvider } from '@bitbot/ui-design';
import { HoxRoot } from 'hox';

export const ModelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <UIProvider>
      <TRPCProvider>
        <AdminTRPCProvider>
          <HoxRoot>{children}</HoxRoot>
        </AdminTRPCProvider>
      </TRPCProvider>
    </UIProvider>
  );
};
